import { ajaxService } from '../../common/Services';
import ChannelCollection from './channel-collection';
import Model from './channel-model';
import { ApiUtils } from '../../common/api';

function fetchChannels() {
  return ajaxService
    .get('/api/xp/channel/list')
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(ChannelCollection.deserialize)
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
}

function _saveSerializedChannel(serializedPayload) {
  const { id, ...rest } = serializedPayload;
  return ajaxService
    .post(`/api/xp/channel/update/${id}`, { ...rest }, undefined, { postJSON: true })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(Model.deserialize)
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
}

function saveChannel(channel) {
  return _saveSerializedChannel(Model.serialize(channel));
}

function deauthChannel(id) {
  return ajaxService
    .get(`/api/xp/channel/deauth/${id}`)
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(Model.deserialize)
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
}

function deleteChannel(id) {
  return ajaxService
    .post(`/api/xp/channel/delete/${id}`)
    .then(ApiUtils.validate)
    .catch((error) => error);
}

function createChannel(channel) {
  return _createSerializedChannel(Model.serialize(channel));
}

function _createSerializedChannel(channel) {
  return ajaxService
    .post('/api/xp/channel/saveWizard', channel, undefined, { postJSON: true })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(Model.deserialize)
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
}

function createContainer(container) {
  return ajaxService
    .post('/api/channel/createContainer.json', container)
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
}

function checkChannelQuotas() {
  return ajaxService
    .post('/api/channel/checkQuotas.json')
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .catch((error) => ({ error: ApiUtils.buildErrorObject(error) }));
}

export default {
  checkChannelQuotas,
  createChannel,
  createContainer,
  deauthChannel,
  deleteChannel,
  fetchChannels,
  saveChannel,
};
